import {IMAGE_DEFAULT_FORMATS} from "../app/consts";
import {AssetsQaRequestParams} from "../../infrastructure/models/params/assets-qa-request-params";

export class ClockAssetsRequestParams extends AssetsQaRequestParams {
  constructor(width: Number, height: Number, color: String) {
    super(width, height, color);

    this.resourceName = this.resourceName + `/allscores/clock`;
    this.version = 3;
    this.ratio = 3;
    this.c = null;
    this.color = color;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.PNG;
  }
}
